import type { TimeTrackingSummaryTabState } from "./timeTrackingPayroll.interfaces";

import { sortingAndSearchFilterParams } from "@/app/constants/constants";
import { TS_SUMMARY_TABS } from "@/app/constants/tabs.constant";

export {
  ApprovalStatus,
  SheetType,
  TimeTrackingSessionKeys,
} from "./timeTrackingPayroll.types";

export const TT_EMPLOYEE_FILTER_KEYS = [
  "fortnight",
  "startDate",
  "endDate",
  "projectId",
  ...sortingAndSearchFilterParams,
];

export const TT_SUMMARY_FILTER_KEYS = [
  "fortnight",
  "startDate",
  "endDate",
  "projectId",
  "date",
  "isVerified",
  ...sortingAndSearchFilterParams,
];

export const TIME_TRACKING_SUMMARY_VERIFICATION_BY_TAB: Record<
  string,
  TimeTrackingSummaryTabState
> = {
  [TS_SUMMARY_TABS[0].value]: { isVerified: false },
  [TS_SUMMARY_TABS[1].value]: { isVerified: true },
  [TS_SUMMARY_TABS[2].value]: { isVerified: undefined },
};

export const TIME_TRACKING_APPROVAL_ROUTES = {
  acceptTimesheet: "general/timesheet/employee/payroll/approve",
  employeePayrollDetails: "general/timesheet/employee/payroll",
};

export const timeTrackingSettingsRoutes = {
  breakById: "workspace/:workspace/timetracking/settings/break/:id",
  holidayByFilters:
    "workspace/:workspace/timetracking/settings/holiday/:filters",
  holidayById: "workspace/:workspace/timetracking/settings/holiday/:holidayId",
  holidaySettings:
    "workspace/:workspace/timetracking/settings/holiday/settings",
  settingByType: "workspace/:workspace/timetracking/settings/:settingType",
  settingByTypeFilters:
    "workspace/:workspace/timetracking/settings/:type/:filters",
  shiftsByCategory:
    "workspace/:workspace/timetracking/settings/shift/:shiftCategory",
};

export const timeTrackingPayrollRoutes = {
  dailyProjects: "workspace/:workspace/timetracking/Sheet/projects",
  fullFortnightSheet:
    "workspace/:workspace/timetracking/Sheet/:sheetType/:employeeId/Sheet",
  payrollApproval:
    "workspace/:workspace/timetracking/Sheet/payroll/approval/:approvalId",
  reportWithWorkHours: "workspace/:workspace/report/daily/with-workhours",
  sheetByType: "workspace/:workspace/timetracking/Sheet/:sheetType",
  singleSheetByType:
    "workspace/:workspace/timetracking/Sheet/:sheetType/:userSheetId",
  singleSheet:
    "workspace/:workspace/timetracking/Sheet/:sheetType/Sheet/:userSheetId",
  timesheetPayrollByEmployee:
    "workspace/:workspace/timetracking/Sheet/payroll/employee/:employeeId",
  timesheetPayrollSend:
    "workspace/:workspace/timetracking/Sheet/payroll/employee/:employeeId/send",
  timesheetPayrollSave:
    "workspace/:workspace/timetracking/Sheet/payroll/employee/:employeeId/save",
};

export const TIMESHEET_WORKING_HOURS = {
  NORMAL_HOURS: "Normal Hours",
  OVERNIGHT_HOURS: "Overnight Hours",
  WEEKEND: "Weekend",
} as const;
